export default "__VITE_ASSET__da65abe5__"